import axios from 'axios';
import { getFriendlyError } from '../utils/friendlyError';
import { env } from '../config/env';
import { storage } from '../utils/storage';

const api = axios.create({
  baseURL: env.apiBaseUrl,
  headers: {
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
  },
});

api.interceptors.request.use((config) => {
  const token = storage.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Stop intermediaries from reusing authenticated GET responses across users.
  config.headers['Cache-Control'] = 'no-cache';
  config.headers.Pragma = 'no-cache';
  if ((config.method || 'get').toLowerCase() === 'get') {
    config.params = {
      ...(config.params || {}),
      _ts: Date.now(),
    };
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      await storage.clearClientCache();
      if (window.location.pathname !== '/login') {
        window.location.assign('/login');
      }
    }
    if (error.response?.data && typeof error.response.data === 'object') {
      error.friendlyMessage = getFriendlyError(error);
    }
    return Promise.reject(error);
  }
);

export default api;
